export default "__VITE_ASSET__COuMYr23__"